import { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { auth } from './lib/api';
import { Shell } from './components/Shell';
import { SignIn } from './pages/SignIn';
import { Orgs } from './pages/Orgs';
import { Activities } from './pages/Activities';
import { ActivityEditor } from './pages/ActivityEditor';
import { Fans } from './pages/Fans';
import { Staff } from './pages/Staff';
import { Economy } from './pages/Economy';
import { Webhooks } from './pages/Webhooks';

export function App() {
  const [, force] = useState(0);
  useEffect(() => {
    const off = auth.subscribe(() => force((n) => n + 1));
    return () => { off(); };
  }, []);
  if (!auth.session) return <SignIn />;
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Orgs />} />
        <Route path="/orgs/:orgId" element={<Activities />} />
        <Route path="/orgs/:orgId/activities/new" element={<ActivityEditor />} />
        <Route path="/orgs/:orgId/activities/:activityId" element={<ActivityEditor />} />
        <Route path="/orgs/:orgId/fans" element={<Fans />} />
        <Route path="/orgs/:orgId/economy" element={<Economy />} />
        <Route path="/orgs/:orgId/webhooks" element={<Webhooks />} />
        <Route path="/staff" element={<Staff />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}
